import React, {useContext} from "react";
import "./SkillsShowcase.scss";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import usePortfolioContent from "../../hooks/usePortfolioContent";

export default function SkillsShowcase() {
  const {isDark} = useContext(StyleContext);
  const {skillsShowcase} = usePortfolioContent();

  if (!skillsShowcase.display) {
    return null;
  }

  return (
    <section className={isDark ? "dark-mode main" : "main"} id="skills" aria-label={skillsShowcase.title}>
      <Fade bottom duration={1000} distance="20px">
        <h2 className={isDark ? "dark-mode skills-showcase-heading" : "skills-showcase-heading"}>
          {skillsShowcase.title}
        </h2>
        <p
          className={
            isDark ? "dark-mode subTitle skills-showcase-subtitle" : "subTitle skills-showcase-subtitle"
          }
        >
          {skillsShowcase.subTitle}
        </p>

        <div className="skills-bento-grid">
          {skillsShowcase.groups.map((group, i) => (
            <div key={i} className="skill-group-card">
              <h3 className="skill-group-title">{group.groupName}</h3>
              <ul className="skill-chip-list">
                {group.skills.map((skill, j) => (
                  <li key={j} className="skill-chip">
                    <i className={skill.fontAwesomeClassname}></i>
                    <span>{skill.skillName}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {skillsShowcase.languages && (
            <div className="skill-group-card">
              <h3 className="skill-group-title">{skillsShowcase.languages.groupName}</h3>
              <ul className="language-list">
                {skillsShowcase.languages.items.map((langItem, k) => (
                  <li key={k} className="language-row">
                    <span className="language-name">{langItem.name}</span>
                    <span className="language-level">{langItem.level}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Fade>
    </section>
  );
}
